module.exports = __webpack_public_path__ + "static/Group 6649-b2ec768712e2fca2db002ce68d1fd21b.png";